// import external dependencies
import "jquery";

// Import everything from autoload
import "./autoload/_foundation.js";

// Import jquery.hotkeys
import "jquery.hotkeys/jquery.hotkeys.js";
import "spectrum-colorpicker/spectrum.js";
import "progressbar.js//src/main";

// import local dependencies
import Router from "./util/Router";
import common from "./routes/common";
import login from "./routes/login";
import signup from "./routes/signup";

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Login page
  login,
  // Signup page
  signup,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js